// Auto-login ให้อัตโนมัติเมื่อเข้าเว็บผ่าน subdomain ที่กำหนดไว้ใน
// src/config/subdomainAccounts.js
//
// ไฟล์นี้แยกออกมาต่างหากเพื่อให้ maintain ง่าย: ถ้าต้องเพิ่ม subdomain ใหม่
// ให้ไปแก้ที่ src/config/subdomainAccounts.js ที่เดียว ไม่ต้องแตะไฟล์นี้
import subdomainAccounts from '@/config/subdomainAccounts';

// เก็บ promise ไว้กัน auto-login ถูกยิงซ้ำหลายครั้งพร้อมกัน
// (เช่นตอน route guard ทำงานหลายรอบติดกันตอนโหลดหน้าแรก)
let autoLoginPromise = null;

// ดึงชื่อ subdomain จาก hostname ปัจจุบัน
// เช่น bangyaisao.envionyx.sgroupinnovation.com -> "bangyaisao"
// ถ้าเป็น domain หลัก / localhost / IP (ไม่มี subdomain จริง) จะ return null
function getCurrentSubdomain() {
  const host = window.location.hostname;

  if (!host || host === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
    return null;
  }

  const parts = host.split('.');
  // ต้องมีอย่างน้อย 3 ส่วน (subdomain.domain.tld) ถึงจะถือว่ามี subdomain
  if (parts.length < 3) {
    return null;
  }

  return parts[0];
}

async function performAutoLogin(subdomain, account) {
  try {
    const response = await fetch(`${process.env.VUE_APP_API_URL}/auth/signin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: account.username,
        password: account.password,
      }),
    });

    const data = await response.json();

    if (response.ok && data.accessToken) {
      localStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('refreshToken', data.refreshToken);
      localStorage.setItem('role', data.user.role);
      localStorage.setItem('email', data.user.email);
      console.log(`[auto-login] เข้าสู่ระบบอัตโนมัติสำหรับ subdomain "${subdomain}" สำเร็จ`);
    } else {
      console.warn(`[auto-login] เข้าสู่ระบบอัตโนมัติสำหรับ subdomain "${subdomain}" ไม่สำเร็จ:`, data.message || data);
    }
  } catch (error) {
    console.error(`[auto-login] เกิดข้อผิดพลาดขณะ auto-login สำหรับ subdomain "${subdomain}":`, error);
  }
}

// เรียกฟังก์ชันนี้ก่อนเข้าหน้าไหนก็ได้ที่ต้องการ token (เช่นใน router.beforeEach)
// ถ้ามี accessToken อยู่แล้ว หรือ subdomain ปัจจุบันไม่ได้อยู่ในรายชื่อ จะไม่ทำอะไรเลย
export function autoLoginForSubdomain() {
  if (autoLoginPromise) {
    return autoLoginPromise;
  }

  if (localStorage.getItem('accessToken')) {
    autoLoginPromise = Promise.resolve();
    return autoLoginPromise;
  }

  const subdomain = getCurrentSubdomain();
  const account = subdomain ? subdomainAccounts[subdomain] : null;

  if (!account) {
    autoLoginPromise = Promise.resolve();
    return autoLoginPromise;
  }

  autoLoginPromise = performAutoLogin(subdomain, account);
  return autoLoginPromise;
}
